import React from 'react';
import PropTypes from 'prop-types';

import FormManager from 'src/core/gd-form/common/form-manager';
import DatepickerComponent from 'core/gd-components/datetime/datepicker/datepicker';

import CustomFieldAddFormProto from "../../add-form-proto";
import CustomFieldLeftPanel from "../../common/panel/form-left-panel";
import CustomFieldPreview from "../../common/form-preview";
import CustomFieldRightPanel from "core/fields/custom/common/panel/form-right-panel";

export default class DateCustomFieldForm extends CustomFieldAddFormProto {

    static propTypes = {
        customField: PropTypes.object,

        onSubmit: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);

        this.type = gd.const.customFields.type.DATE;

        this.form = new FormManager(this.formStructure, this.initFormData);
    }

    onSubmit(result) {
        result.name = result.name.trim();
        result.type = gd.const.customFields.type.DATE;

        result.params = {
            displayName : result.displayName?.trim(),
            scope       : result.scope
        };

        this.props.onSubmit(result);
    }

    render() {
        return (
            <React.Fragment>
                <CustomFieldLeftPanel parent={this}>
                    <CustomFieldPreview noPadding={true}>
                        <div className="gd-field-date view disabled m-l-10">
                            <DatepickerComponent value={Moment()}
                                                 markPastdue={false}
                                                 valueFormat="MMM DD, YYYY"
                                                 disabled={true} />
                        </div>
                    </CustomFieldPreview>
                </CustomFieldLeftPanel>

                <CustomFieldRightPanel parent={this}/>
            </React.Fragment>
        )
    }
}